import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import style from './PublicFooter.module.scss';

const PublicFooter = ({ white }) => {
  return (
    <footer className={classNames(style.container, { [style.white]: white })}>
      <div className={style.wrapper}>
        <span>
          app.dentametr.pl
          <span className={style.conjunction}> -</span>
        </span>
        <Link
          to='/privacy-policy'
          className={style.link}
        >
          Polityka prywatności
        </Link>
        <span className={style.conjunction}> | </span>
        <Link
          to='/statute'
          className={style.link}
        >
          Regulamin platformy
        </Link>
        <span className={style.conjunction}> | </span>
        <Link
          to='/faq'
          className={style.link}
        >
          FAQ
        </Link>
      </div>
      <div className={style.wrapper}>Copyright &copy; {new Date().getFullYear()} by Dentametr</div>
    </footer>
  );
};

export default PublicFooter;
